/// <reference path="../../common/inputs/richtext/richtext.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../../teva/storage/storage.ts" />
/// <reference path="../../../teva/colorpicker/colorpicker.ts" />
/// <reference path="../../../teva/sortable/sortable.ts" />
/// <reference path="../../crm/main/main.ts" />

namespace OfficeGuy.Apps {
    export class HTMLEditor {
        static WidgetsDefinitions: any;
        static TemplateParameters: any;
        static UploadImageURL: string;
        static IsEmailEditor: boolean;
        static CompanyLogoPath: string;
        static Function_CreateWidgetByName: any;

        static WidgetButtonsPicker(Event, Container, Prepend) {
            Event.stopPropagation();
            var $WidgetContainer = $(document.createElement('div'));
            HTMLEditor.RenderWidgetsButtons($WidgetContainer, Container, Prepend);

            OfficeGuy.Modals.ShowHTMLDialog({
                HTML: $WidgetContainer,
                Title: "הוספת רכיב"
            });
        }
        static RenderWidgetsButtons($WidgetContainer, $Container, Prepend) {
            for (var i = 0; i < HTMLEditor.WidgetsDefinitions.length; i++) {
                var Widget = HTMLEditor.WidgetsDefinitions[i];
                var $Button = $(document.createElement('div'))
                    .addClass("htmleditor-buttons-widget")
                    .attr("title", Widget.DisplayName)
                    .data("WidgetName", Widget.Name)
                    .on("click", function () {
                        Forms.SetDirty();
                        var Widget = <HTMLEditor_Widget>HTMLEditor.Function_CreateWidgetByName($(this).data("WidgetName"));
                        HTMLEditor.RenderWidget(Widget, false);
                        if (Prepend)
                            Widget.$HTMLElement.hide().prependTo($Container).fadeIn();
                        else
                            Widget.$HTMLElement.hide().appendTo($Container).fadeIn();
                        OfficeGuy.Modals.HideAll();
                        Teva.Positioning.ScrollToElement(Widget.$HTMLElement);
                        $(".htmleditor-widget-active").removeClass("htmleditor-widget-active");
                        Widget.$HTMLElement.addClass("htmleditor-widget-active");
                        HTMLEditor.InitWidgetContainers();
                        return false;
                    });
                HTMLEditor.RenderWidget(Widget, true);
                Widget.$HTMLElement.find("[contenteditable]").attr("contenteditable", null);
                $Button.append(Widget.$HTMLElement);

                $WidgetContainer.append($Button);
            }
        }
        static TemplateStyleEditor() {
            var $TemplatePanel = $(document.createElement('div'));
            var $LastAccordion = null;
            var LastCategory = null;
            for (var i = 0; i < HTMLEditor.TemplateParameters.length; i++) {
                var $ParameterEditor = HTMLEditor.RenderParameterEditor(null, HTMLEditor.TemplateParameters[i]);
                if ($ParameterEditor == null)
                    continue;

                if (HTMLEditor.TemplateParameters[i].Category != LastCategory) {
                    LastCategory = HTMLEditor.TemplateParameters[i].Category;
                    if (LastCategory != null && LastCategory != "") {
                        var AccordionID = "htmleditor-" + LastCategory;
                        $TemplatePanel.append($(document.createElement('div'))
                            .addClass("og-accordion")
                            .toggleClass("og-accordion-open", Teva.Storage.LocalStorage_Get("Accordion_" + AccordionID) != "0")
                            .attr("data-accordionid", AccordionID)
                            .append($(document.createElement('div'))
                                .addClass("og-accordion-link")
                                .text(LastCategory))
                            .append($LastAccordion = $(document.createElement('div'))
                                .addClass("og-accordion-content")
                            ));
                    }
                }
                if ($LastAccordion == null)
                    $TemplatePanel.append($ParameterEditor);
                else
                    $LastAccordion.append($ParameterEditor);
                HTMLEditor.RenderParameter(null, HTMLEditor.TemplateParameters[i], false);
            }
            OfficeGuy.Modals.ShowHTMLDialog({
                HTML: $TemplatePanel,
                Title: "עיצוב כללי"
            });
            Teva.ColorPicker.Init();
        }
        static WidgetStyleEditor(Widget: HTMLEditor_Widget) {
            $(".htmleditor-widget-active").removeClass("htmleditor-widget-active");
            Widget.$HTMLElement.addClass("htmleditor-widget-active");

            var $ContentsPanel = $(document.createElement('div'));

            var $LastAccordion = null;
            var LastCategory = null;
            for (var i = 0; i < Widget.Parameters.length; i++) {
                var $ParameterEditor = HTMLEditor.RenderParameterEditor(Widget, Widget.Parameters[i]);
                if ($ParameterEditor == null)
                    continue;
                if (Widget.Parameters[i].Category != LastCategory) {
                    LastCategory = Widget.Parameters[i].Category;
                    if (LastCategory != null && LastCategory != "") {
                        var AccordionID = "htmleditor-" + LastCategory;
                        $ContentsPanel.append($(document.createElement('div'))
                            .addClass("og-accordion")
                            .toggleClass("og-accordion-open", Teva.Storage.LocalStorage_Get("Accordion_" + AccordionID) != "0")
                            .attr("data-accordionid", AccordionID)
                            .append($(document.createElement('div'))
                                .addClass("og-accordion-link")
                                .text(LastCategory))
                            .append($LastAccordion = $(document.createElement('div'))
                                .addClass("og-accordion-content")));
                    }
                }
                if ($LastAccordion == null)
                    $ContentsPanel.append($ParameterEditor);
                else
                    $LastAccordion.append($ParameterEditor);
            }
            OfficeGuy.Modals.ShowHTMLDialog({
                HTML: $ContentsPanel,
                Title: "עיצוב רכיב"
            });
            Teva.ColorPicker.Init();
        }

        static InitEditor() {
            var $ButtonsPanel = $(".htmleditor-buttons");
            HTMLEditor.RenderWidgetsButtons($ButtonsPanel, $('.htmleditor-content'), false);

            for (var i = 0; i < HTMLEditor.TemplateParameters.length; i++)
                HTMLEditor.RenderParameter(null, HTMLEditor.TemplateParameters[i], false);

            Teva.Sortable.Enable($('.htmleditor-content'), {
                ItemSelector: "> .htmleditor-widget",
                HandleSelector: "> .htmleditor-widget > .htmleditor-widget-button-container > .htmleditor-widget-button-handle",
                PreserveWidth: true,
                OnChange: function () {
                    Forms.SetDirty();
                }
            });
            $(".htmleditor-editor").data("TemplateParameters", HTMLEditor.TemplateParameters);

            var JSON = <string>$(".htmleditor-widgets input").val();
            var Widgets = null;
            if (JSON != null && JSON.length > 0)
                Widgets = HTMLEditor.Deserialize(JSON);
            $(document.createElement('div'))
                .addClass("og-button-ui-action og-button-color-default htmleditor-appendwidgetbutton")
                .text("הוספת רכיב")
                .css("width", "100%")
                .on("click", function (Event) {
                    HTMLEditor.WidgetButtonsPicker(Event, $('.htmleditor-content'), false);
                    return false;
                })
                .insertAfter($('.htmleditor-content'));

            $(document.createElement('div'))
                .addClass("og-button-ui-action og-button-color-default htmleditor-prependwidgetbutton")
                .text("הוספת רכיב")
                .css("width", "100%")
                .on("click", function (Event) {
                    HTMLEditor.WidgetButtonsPicker(Event, $('.htmleditor-content'), true);
                    return false;
                })
                .insertBefore($('.htmleditor-content'));

            HTMLEditor.InitWidgetContainers();

            var Floating = false;

            $(".htmleditor-panel-contents").on("click.image", ".htmleditor-editor-imagecontainer", function () {
                HTMLEditor.ImagePicker($(this).find("img").first());
                return false;
            });
            $(window).off("resize.htmleditor").on("resize.htmleditor", function () {
                var $MenuElement = $(".htmleditor-panel-menu");
                if ($MenuElement.length == 0) {
                    $(window).off("resize.htmleditor");
                    return;
                }
                if (window.innerWidth < 1370) {
                    if (Floating) {
                        // Disable float
                        $MenuElement.css("overflow-y", "visible").css("height", "auto");
                        Floating = false;
                    }
                }
                else {
                    if (Floating) {
                        // move
                        $MenuElement.css("height", $(window).height() - ($(".og-topbar").length == 0 ? 0 : $(".og-topbar").height()) - ($(".og-navigation-bar").length == 0 ? 0 : $(".og-navigation-bar").height()));
                    }
                    else {
                        // Initial float
                        $MenuElement.css("overflow-y", "auto").css("height", $(window).height() - ($(".og-topbar").length == 0 ? 0 : $(".og-topbar").height()) - ($(".og-navigation-bar").length == 0 ? 0 : $(".og-navigation-bar").height()));
                        Floating = true;
                    }
                }
            }).trigger("resize.htmleditor");
            $(window).off("scroll.htmleditor").on("scroll.htmleditor", function () {
                var $MenuElement = $(".htmleditor-panel-menu");
                if ($MenuElement.length == 0)
                    $(window).off("scroll.htmleditor");
                else if (Floating) {
                    var MarginTop = Math.min(window.scrollY, $(".htmleditor-panel.htmleditor-panel-contents").offset().top + $(".htmleditor-panel.htmleditor-panel-contents").height() - $(".htmleditor-panel-menu").height());
                    if (MarginTop < 0)
                        MarginTop = 0;
                    $MenuElement.css("margin-top", MarginTop + "px");
                }
            }).trigger("scroll.htmleditor")
        }
        static InitWidgetContainers() {
            $(".htmleditor-widgetcontainer:not(.htmleditor-widgetcontainer-initialized)").each(function () {
                var $WidgetContainer = $(this);
                $WidgetContainer.addClass("htmleditor-widgetcontainer-initialized");
                $(document.createElement('div'))
                    .addClass("og-button-ui-action og-button-color-default htmleditor-appendwidgetbutton")
                    .css("width", "100%")
                    .text("הוספת רכיב")
                    .on("click", function (Event) {
                        HTMLEditor.WidgetButtonsPicker(Event, $WidgetContainer, false);
                        return false;
                    })
                    .insertAfter($(this));
            });
            Teva.Sortable.Enable($('.htmleditor-widgetcontainer'), {
                ItemSelector: "> .htmleditor-widget",
                HandleSelector: "> .htmleditor-widget > .htmleditor-widget-button-container > .htmleditor-widget-button-handle",
                PreserveWidth: true
            });
        }

        static RenderWidget(Widget: HTMLEditor_Widget, Preview: boolean) {
            Widget.$HTMLElement = $(document.createElement('div'))
                .data("Widget", Widget)
                .addClass("htmleditor-widget")
                .append(jQuery.parseHTML(Widget.Template));

            if (!Preview) {
                Widget.$HTMLElement
                    .on("click", function (Event) {
                        var Widget = <HTMLEditor_Widget>$(this).data("Widget");
                        var AlreadyActive = Widget.$HTMLElement.hasClass("htmleditor-widget-active");
                        if (Widget.$HTMLElement.find(".htmleditor-widget").length > 0)
                            return true;

                        $(".htmleditor-widget-active").removeClass("htmleditor-widget-active");
                        Widget.$HTMLElement.addClass("htmleditor-widget-active");
                        return AlreadyActive && !$(Event.target).is("a");
                    })
                    //.find("td:first").css("position", "relative")
                    .append($(document.createElement('div'))
                        .addClass("htmleditor-widget-button-container")
                        .append($(document.createElement('div'))
                            .addClass("htmleditor-widget-button htmleditor-widget-button-handle")
                        )
                        .append($(document.createElement('div'))
                            .addClass("htmleditor-widget-button htmleditor-widget-button-design using-tooltip")
                            .attr("title", "עריכה")
                            .on("click", function () {
                                Inputs.RichText.HideFloating();
                                HTMLEditor.WidgetStyleEditor(Widget);
                                return false;
                            })
                        )
                        .append($(document.createElement('div'))
                            .addClass("htmleditor-widget-button htmleditor-widget-button-clone using-tooltip")
                            .attr("title", "שכפול")
                            .on("click", function () {
                                Forms.SetDirty();
                                Inputs.RichText.HideFloating();
                                var ClonedWidget = <HTMLEditor_Widget>HTMLEditor.Function_CreateWidgetByName(Widget.Name);
                                HTMLEditor.PrepareStorage_Widget(Widget);
                                ClonedWidget.Parameters = [];
                                for (var i = 0; i < Widget.Parameters.length; i++) {
                                    var Parameter = Widget.Parameters[i];

                                    ClonedWidget.Parameters.push({
                                        Name: Parameter.Name,
                                        Value: Parameter.Value,
                                        Category: Parameter.Category,
                                        DisplayName: Parameter.DisplayName,
                                        Type: Parameter.Type,
                                        $HTMLElements: null
                                    });
                                }

                                HTMLEditor.RenderWidget(ClonedWidget, false);
                                var $Container = Widget.$HTMLElement.closest(".htmleditor-widget");
                                if ($Container.length != 0)
                                    ClonedWidget.$HTMLElement.hide().insertAfter($Container).fadeIn();
                                else {
                                    $Container = Widget.$HTMLElement.closest(".htmleditor-widgetcontainer");
                                    if ($Container.length == 0)
                                        $Container = $('.htmleditor-content');
                                    ClonedWidget.$HTMLElement.hide().appendTo($Container).fadeIn();
                                }
                                Teva.Positioning.ScrollToElement(ClonedWidget.$HTMLElement);
                                return false;
                            })
                        )
                        .append($(document.createElement('div'))
                            .addClass("htmleditor-widget-button htmleditor-widget-button-remove using-tooltip")
                            .attr("title", "מחיקה")
                            .on("click", function () {
                                Forms.SetDirty();
                                Inputs.RichText.HideFloating();
                                var $Container = $(this).closest(".htmleditor-widget").parents(".htmleditor-widget");
                                $(this).closest(".htmleditor-widget").remove();
                                $(".htmleditor-widget-active").removeClass("htmleditor-widget-active");
                                $("#Tab_Widgets").prop("checked", true).trigger("change");
                                OfficeGuy.Common.Tooltip_Hide();
                                if ($Container.length > 0 && $Container.find(".htmleditor-widget").length == 0)
                                    $Container.addClass("htmleditor-widget-active");
                                return false;
                            })
                        )
                    );
            }

            for (var i = 0; i < Widget.Parameters.length; i++) {
                Widget.Parameters[i].$HTMLElements = null;
                HTMLEditor.RenderParameter(Widget, Widget.Parameters[i], Preview);
            }
            if (Widget.Widgets != null) {
                var $Containers = Widget.$HTMLElement.find(".htmleditor-widgetcontainer");
                for (var i = 0; i < Widget.Widgets.length; i++) {
                    for (var j = 0; j < Widget.Widgets[i].length; j++) {
                        HTMLEditor.RenderWidget(Widget.Widgets[i][j], Preview);
                        $($Containers[i]).append(Widget.Widgets[i][j].$HTMLElement);
                    }
                }
            }
            Widget.$HTMLElement.find(".og-email-header-logo").attr("src", HTMLEditor.CompanyLogoPath);
        }

        static RenderParameter(Widget: HTMLEditor_Widget, Parameter: HTMLEditor_Parameter, Preview: boolean) {
            var $HTMLElements;
            if (Widget == null) {
                $HTMLElements = $(".htmleditor-panel-contents").find('[og-email-template-parameter]');
                if (Parameter.$HTMLElements == null) {
                    for (var i = 0; i < $HTMLElements.length; i++) {
                        var $InnerHTMLElement = $($HTMLElements[i]);
                        if ($InnerHTMLElement.attr("og-email-template-parameter").split(',').indexOf(Parameter.Name) != -1) {
                            if (Parameter.$HTMLElements == null)
                                Parameter.$HTMLElements = $InnerHTMLElement;
                            else
                                Parameter.$HTMLElements = Parameter.$HTMLElements.add($InnerHTMLElement);
                        }
                    }
                }
            }
            else {
                $HTMLElements = Widget.$HTMLElement.find('[og-email-parameter]');
                if (Parameter.$HTMLElements == null) {
                    for (var i = 0; i < $HTMLElements.length; i++) {
                        var $InnerHTMLElement = $($HTMLElements[i]);
                        if ($InnerHTMLElement.attr("og-email-parameter").split(',').indexOf(Parameter.Name) != -1) {
                            if (Parameter.$HTMLElements == null)
                                Parameter.$HTMLElements = $InnerHTMLElement;
                            else
                                Parameter.$HTMLElements = Parameter.$HTMLElements.add($InnerHTMLElement);
                        }
                    }
                }
            }
            if (Parameter.$HTMLElements == null) {
                return;//alert("Parameter not found: " + Parameter.Name);
                //return;
            }

            if (Parameter.Value == null)
                Parameter.Value == "";

            switch (Parameter.Type) {
                case "ButtonText":
                case "Text":
                    Parameter.$HTMLElements.empty().append(jQuery.parseHTML(Parameter.Value));
                    if (!Preview)
                        Parameter.$HTMLElements.attr("contenteditable", true);
                    break;
                case "HTML":
                    var $RichTextEditor = $(document.createElement('div'))
                        .append(jQuery.parseHTML(Parameter.Value));

                    Parameter.$HTMLElements.append($RichTextEditor);
                    if (!Preview) {
                        $RichTextEditor
                            .attr("id", "RichTextEditor_1")
                            .addClass("og-richtexteditor og-richtexteditor-floating")
                            .data("richtext-positionselector", ".htmleditor-widget");
                        Inputs.RichText.InitEditors(Parameter.$HTMLElements);
                    }
                    break;
                case "Image":
                    if (Parameter.Value.length == 0)
                        Parameter.$HTMLElements.css("display", "none");
                    else {
                        Parameter.$HTMLElements
                            .css("display", "")
                            .attr("src", Parameter.Value);
                    }
                    if (Preview) {
                        var Width = Parameter.$HTMLElements.css("max-width");
                        var Height = Parameter.$HTMLElements.css("max-height");
                        var $Container = $(document.createElement('div'))
                            .addClass("htmleditor-buttons-widget-imagecontainer")
                            .css("max-width", Width)
                            .css("max-height", Height)
                            .css("padding", Parameter.$HTMLElements.css("padding"))
                            .css("padding-left", Parameter.$HTMLElements.css("padding-left"))
                            .css("padding-right", Parameter.$HTMLElements.css("padding-right"))
                            .css("padding-top", Parameter.$HTMLElements.css("padding-top"))
                            .css("padding-bottom", Parameter.$HTMLElements.css("padding-bottom"))
                            .css("margin", Parameter.$HTMLElements.css("margin"))
                            .css("margin-left", Parameter.$HTMLElements.css("margin-left"))
                            .css("margin-right", Parameter.$HTMLElements.css("margin-right"))
                            .css("margin-top", Parameter.$HTMLElements.css("margin-top"))
                            .css("margin-bottom", Parameter.$HTMLElements.css("margin-bottom"))
                            .css("margin-bottom", Parameter.$HTMLElements.css("vertical-align"));
                        Parameter.$HTMLElements
                            .css("padding", "")
                            .css("padding-left", "")
                            .css("padding-right", "")
                            .css("padding-top", "")
                            .css("padding-bottom", "")
                            .css("margin", "")
                            .css("margin-left", "")
                            .css("margin-right", "")
                            .css("margin-top", "")
                            .css("margin-bottom", "")
                            .css("vertical-align", "");

                        Parameter.$HTMLElements.wrap($Container);
                        Width = Width.replace("px", "")
                        Height = Height.replace("px", "")
                        Parameter.$HTMLElements.parent().append($(document.createElement('div'))
                            .addClass("htmleditor-buttons-widget-imagecontainer-dimensions")
                            .text(Width.length == 0 || Height.length == 0 ? "" : Width + " x " + Height)
                            .css("font-size", (Width / 6) + "px"));
                    }
                    break;
                case "BackgroundImage":
                    if (Parameter.Value.length == 0)
                        Parameter.$HTMLElements.css("background-image", "");
                    else
                        Parameter.$HTMLElements.css("background-image", "url(" + Parameter.Value + ")");
                    break;
                case "BackgroundSize":
                    Parameter.$HTMLElements.css("background-size", Parameter.Value);
                    break;
                case "AlternativeText":
                    Parameter.$HTMLElements
                        .attr("alt", Parameter.Value.length == 0 ? null : Parameter.Value)
                        .attr("title", Parameter.Value.length == 0 ? null : Parameter.Value);
                    break;
                case "Href":
                    Parameter.$HTMLElements.attr("href", Parameter.Value);
                    break;
                case "HrefHidden":
                    Parameter.$HTMLElements
                        .attr("href", Parameter.Value)
                        .toggle(Parameter.Value.length != 0);
                    break;
                case "BackgroundColor":
                    Parameter.$HTMLElements.css("background-color", Parameter.Value);
                    break;
                case "BoxShadow":
                    Parameter.$HTMLElements.css("box-shadow", Parameter.Value.length == 0 || Parameter.Value == "0" ? "none" : "0 " + Parameter.Value + "px " + (Number(Parameter.Value) * 5 / 2) + "px rgba(0,0,0,.26)");
                    break;
                case "MaxWidth":
                    Parameter.$HTMLElements.css("max-width", Parameter.Value.length == 0 ? "" : Parameter.Value + "px");
                    break;
                case "Width":
                    Parameter.$HTMLElements.css("width", Parameter.Value.length == 0 ? "" : Parameter.Value + "px");
                    break;
                case "WidthPercent":
                    Parameter.$HTMLElements.css("width", Parameter.Value + "%");
                    break;
                case "MaxWidthAlignment":
                    Parameter.$HTMLElements
                        .css("margin-right", Parameter.Value == "left" || Parameter.Value == "center" ? "auto" : "")
                        .css("margin-left", Parameter.Value == "center" ? "auto" : "");
                    break;
                case "TextAlignment":
                    Parameter.$HTMLElements.css("text-align", Parameter.Value);
                    break;
                case "ButtonBackgroundColor":
                    Parameter.$HTMLElements
                        .css("background-color", Parameter.Value)
                        .css("border-width", "1px")
                        .css("border-style", "solid")
                        .css("border-color", Parameter.Value);
                    break;
                case "ButtonBackgroundColorHover":
                    Parameter.$HTMLElements.attr("data-backgroundcolorhover", Parameter.Value.length == 0 ? "transparent" : Parameter.Value);
                    break;
                case "TextColor":
                    Parameter.$HTMLElements.css("color", Parameter.Value);
                    break;
                case "TextColorHover":
                    Parameter.$HTMLElements.attr("data-colorhover", Parameter.Value);
                    break;
                case "TextSize":
                    Parameter.$HTMLElements.css("font-size", Parameter.Value.length == 0 ? "" : Parameter.Value + "px");
                    break;
                case "TextBold":
                    Parameter.$HTMLElements.css("font-weight", Parameter.Value == "1" ? "bold" : "");
                    break;
                case "Padding":
                    Parameter.$HTMLElements.css("padding", "");
                    if (!(<any>isNaN)(Parameter.Value))
                        Parameter.$HTMLElements.css("padding", Parameter.Value + "px");
                    else {
                        Parameter.Value = Parameter.Value.replace(/,/g, ' ');
                        var Values = Parameter.Value.split(' ');
                        if (Values.length == 4)
                            Parameter.$HTMLElements.css("padding", Values[0] + "px " + Values[1] + "px " + Values[2] + "px " + Values[3] + "px");
                    }
                    break;
                case "BorderRadius":
                    Parameter.$HTMLElements.css("border-radius", Parameter.Value.length == 0 ? "" : Parameter.Value + "px");
                    break;
                case "BorderColor":
                    Parameter.$HTMLElements.css("border-style", Parameter.Value.length == 0 ? "" : "solid").css("border-color", Parameter.Value);
                    break;
                case "BorderWidth":
                    Parameter.$HTMLElements.css("border-width", "");
                    if (!(<any>isNaN)(Parameter.Value))
                        Parameter.$HTMLElements.css("border-width", Parameter.Value + "px");
                    else {
                        Parameter.Value = Parameter.Value.replace(/,/g, ' ');
                        var Values = Parameter.Value.split(' ');
                        if (Values.length == 4)
                            Parameter.$HTMLElements.css("border-width", Values[0] + "px " + Values[1] + "px " + Values[2] + "px " + Values[3] + "px");
                    }
                    break;
                case "VerticalAlign":
                    Parameter.$HTMLElements.attr("valign", Parameter.Value);
                    break;
                case "HorizontalAlign":
                    Parameter.$HTMLElements.attr("align", Parameter.Value);
                    break;
                case "FontFamily":
                case "FontFamilyWithDefault":
                    if (Parameter.Value.indexOf("google:") == 0) {
                        var Value = Parameter.Value.substring("google:".length);
                        if (Widget != null)
                            Widget.$HTMLElement.append('<link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=' + encodeURI(Value) + '">');
                        else {
                            $(".htmleditor-content > link").remove();
                            $(".htmleditor-content").prepend('<link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=' + encodeURI(Value) + '">');
                        }
                        Parameter.$HTMLElements.css("font-family", Value);
                    }
                    else
                        Parameter.$HTMLElements.css("font-family", Parameter.Value);
                    break;
                case "ImageDimensions":
                    var ImageWidth = Parameter.Value.split('x')[0];
                    var ImageHeight = Parameter.Value.split('x')[1];
                    Parameter.$HTMLElements
                        .css("max-width", ImageWidth + "px");
                    if (Parameter.$HTMLElements.filter("img").attr("width")) {
                        Parameter.$HTMLElements.filter("img")
                            .css("width", Number(ImageWidth) > 300 ? "100%" : ImageWidth + "px")
                            .attr("width", Number(ImageWidth) > 300 ? 300 : ImageWidth);
                    }
                    Parameter.$HTMLElements
                        .css("max-height", ImageHeight + "px");
                    break;
                case "ImageWidth":
                    Parameter.$HTMLElements
                        .css("max-width", Parameter.Value.length == 0 ? "100%" : Parameter.Value + "px");
                    if (Parameter.$HTMLElements.filter("img").attr("width")) {
                        Parameter.$HTMLElements.filter("img")
                            .css("width", Parameter.Value.length == 0 || Number(Parameter.Value) > 300 ? "100%" : Parameter.Value + "px")
                            .attr("width", Parameter.Value.length == 0 || Number(Parameter.Value) > 300 ? 300 : Parameter.Value);
                    }
                    break;
                case "ImageHeight":
                    Parameter.$HTMLElements
                        .css("max-height", Parameter.Value.length == 0 ? "" : Parameter.Value + "px");
                    break;
                case "YouTubeVideoID":
                    var YoutubeID = Parameter.Value;
                    if (YoutubeID.indexOf("youtube.com") != -1 && YoutubeID.indexOf("?v=") != -1) {
                        YoutubeID = YoutubeID.substr(YoutubeID.indexOf("?v=") + "?v=".length);
                        if (YoutubeID.indexOf("&") != -1)
                            YoutubeID = YoutubeID.substr(0, YoutubeID.indexOf("&"));
                    }
                    Parameter.$HTMLElements.filter("img").attr("src", YoutubeID.length == 0 ? null : "https://img.youtube.com/vi/" + YoutubeID + "/mqdefault.jpg");
                    Parameter.$HTMLElements.filter("a").attr("href", YoutubeID.length == 0 ? null : "https://www.youtube.com/watch?v=" + YoutubeID);
                    break;
                case "CustomHTML":
                    Parameter.$HTMLElements.empty().append(jQuery.parseHTML(Parameter.Value));
                    break;
                case "Schema":
                    Parameter.$HTMLElements.removeAttr("data-schemaid");
                    if (Parameter.Value != null && Parameter.Value.length > 0) {
                        var SchemaID = JSON.parse(Parameter.Value)[0];
                        Parameter.$HTMLElements.attr("data-schemaid", SchemaID);
                    }
                    break;
                case "EntityLayout":
                    Parameter.$HTMLElements
                        .toggleClass("entitylayout-center", Parameter.Value == "center")
                        .toggleClass("entitylayout-start", Parameter.Value == "start")
                        .toggleClass("entitylayout-row", Parameter.Value == "row");
                    break;
                case "EntityButtonText":
                    Parameter.$HTMLElements.attr("data-button-text", Parameter.Value);
                    break;
                case "EntityButtonBackground":
                    Parameter.$HTMLElements.attr("data-button-background", Parameter.Value);
                    break;
                case "EntityButtonBackgroundMouseover":
                    Parameter.$HTMLElements.attr("data-button-background-hover", Parameter.Value);
                    break;
                case "EntityButtonColor":
                    Parameter.$HTMLElements.attr("data-button-color", Parameter.Value);
                    break;
                case "EntityButtonColorMouseover":
                    Parameter.$HTMLElements.attr("data-button-color-hover", Parameter.Value);
                    break;
                case "View":
                    break;
                default:
                    alert("Unsupported ParameterType: " + Parameter.Type);
                    break;
            }
        }
        static RenderParameterEditor(Widget: HTMLEditor_Widget, Parameter: HTMLEditor_Parameter) {
            var $Container = $(document.createElement('div'))
                .addClass("sumit-field")
                .attr("data-parametername", Parameter.Name);
            var $Field = $(document.createElement('div'));

            var InputClass = "input-ShortText";
            var Title = null;
            switch (Parameter.Type) {
                case "ButtonText":
                case "Text":
                case "HTML":
                case "Image":
                    return null;
                case "Padding":
                    Title = "יש להזין את גודל השוליים בפיקסלים.<br />ניתן להזין שוליים נפרדים לכל צד, על ידי כתיבת 4 מספרים מופרדים ברווח.<br />סדר הצדדים, הינו למעלה-ימינה-למטה-שמאלה.";
                    InputClass = "input-ShortText";
                    $Field.append($(document.createElement('input'))
                        .attr("type", "text")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "BorderWidth":
                    Title = "יש להזין את עובי המסגרת בפיקסלים.<br />ניתן להזין עובי מסגרת נפרדת לכל צד, על ידי כתיבת 4 מספרים מופרדים ברווח.<br />סדר הצדדים, הינו למעלה-ימינה-למטה-שמאלה.";
                    InputClass = "input-ShortText";
                    $Field.append($(document.createElement('input'))
                        .attr("type", "text")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "Width":
                case "MaxWidth":
                case "BoxShadow":
                case "WidthPercent":
                    InputClass = "input-Int64";
                    $Field.append($(document.createElement('input'))
                        .attr("type", "number")
                        .attr("step", "1")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "MaxWidthAlignment": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    $Input.append($(document.createElement('option'))
                        .val('right')
                        .text('ימין'));
                    $Input.append($(document.createElement('option'))
                        .val('center')
                        .text('מרכז'));
                    $Input.append($(document.createElement('option'))
                        .val('left')
                        .text('שמאל'));
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                }
                case "TextAlignment": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    $Input.append($(document.createElement('option'))
                        .val('right')
                        .text('ימין'));
                    $Input.append($(document.createElement('option'))
                        .val('center')
                        .text('מרכז'));
                    $Input.append($(document.createElement('option'))
                        .val('left')
                        .text('שמאל'));
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                }
                case "TwoColumnsWidth": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    $Input.append($(document.createElement('option'))
                        .val('50:50')
                        .text('50:50'));
                    $Input.append($(document.createElement('option'))
                        .val('25:75')
                        .text('50:50'));
                    $Input.append($(document.createElement('option'))
                        .val('50:50')
                        .text('50:50'));
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                }
                case "BackgroundImage": {
                    $Field.append($(document.createElement('a'))
                        .addClass("og-button-ui-action og-button-color-default")
                        .text("בחירת תמונה")
                        .on("click", function () {
                            HTMLEditor.BackgroundImagePicker(Parameter);
                        }));
                    $Field.append(" ");
                    $Field.append($(document.createElement('a'))
                        .addClass("og-button-ui-action og-button-color-default")
                        .text("ביטול תמונת רקע")
                        .on("click", function () {
                            $(Parameter.$HTMLElements).css("background-image", "");
                            Parameter.Value = "";
                        }));
                    break;
                }
                case "BackgroundSize": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    $Input.append($(document.createElement('option'))
                        .val('')
                        .text('מקורי'));
                    $Input.append($(document.createElement('option'))
                        .val('cover')
                        .text('כיסוי'));
                    $Input.append($(document.createElement('option'))
                        .val('contain')
                        .text('מכיל'));
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                }
                case "ButtonBackgroundColorHover":
                case "ButtonBackgroundColor":
                case "BackgroundColor":
                case "BorderColor": {
                    var $Input = <any>$(document.createElement('input'))
                        .attr("type", "text")
                        .addClass("colorpicker")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged);
                    if (Parameter.$HTMLElements != null) {
                        var $Parent = Parameter.$HTMLElements.parent();
                        while ($Parent.length > 0) {
                            var BackgroundColor = $Parent.css("background-color");
                            if (BackgroundColor != "" && BackgroundColor != "transparent" && BackgroundColor != "rgba(0, 0, 0, 0)") {
                                $Input.attr("placeholder", HTMLEditor.RGB2Hex(BackgroundColor))
                                break;
                            }
                            $Parent = $Parent.parent();
                        }
                    }
                    $Field.append($Input);
                    break;
                }
                case "EntityButtonBackground":
                case "EntityButtonBackgroundMouseover":
                case "EntityButtonColor":
                case "EntityButtonColorMouseover":
                case "TextColorHover":
                case "TextColor": {
                    var $Input = <any>$(document.createElement('input'))
                        .attr("type", "text")
                        .addClass("colorpicker")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged);
                    if (Parameter.$HTMLElements != null)
                        $Input.attr("placeholder", HTMLEditor.RGB2Hex(Parameter.$HTMLElements.parent().css("color")))
                    $Field.append($Input);
                    break;
                }
                case "VerticalAlign": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    $Input.append($(document.createElement('option'))
                        .val('top')
                        .text('למעלה'));
                    $Input.append($(document.createElement('option'))
                        .val('middle')
                        .text('אמצע'));
                    $Input.append($(document.createElement('option'))
                        .val('bottom')
                        .text('למטה'));
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                }
                case "HorizontalAlign": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    $Input.append($(document.createElement('option'))
                        .val('right')
                        .text('ימין'));
                    $Input.append($(document.createElement('option'))
                        .val('center')
                        .text('אמצע'));
                    $Input.append($(document.createElement('option'))
                        .val('left')
                        .text('שמאל'));
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                }
                case "TextBold":
                    $Field.append($(document.createElement('input'))
                        .attr("type", "checkbox")
                        .prop("checked", Parameter.Value == "1")
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "TextSize":
                    InputClass = "input-Int64";
                    $Field.append($(document.createElement('input'))
                        .attr("type", "number")
                        .attr("step", "1")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "BorderRadius": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    for (var Value = 0; Value < 32; Value++)
                        $Input.append($(document.createElement('option')).val(Value).text(Value));
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                }
                case "ImageWidth":
                case "ImageHeight":
                    InputClass = "input-Int64";
                    $Field.append($(document.createElement('input'))
                        .attr("type", "number")
                        .attr("step", "1")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "Href":
                case "HrefHidden":
                    InputClass = "input-ShortText input-ShortText-URL";
                    $Field.append($(document.createElement('input'))
                        .attr("type", "text")
                        .addClass("ltr")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "AlternativeText":
                    $Field.append($(document.createElement('input'))
                        .attr("type", "text")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "FontFamily":
                case "FontFamilyWithDefault": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    if (Parameter.Type == "FontFamilyWithDefault")
                        $Input.append($(document.createElement('option'))
                            .val('')
                            .text('ברירת מחדל'));
                    $Input.append($(document.createElement('optgroup'))
                        .attr("label", "גופנים רגילים")
                        .append($(document.createElement('option'))
                            .val('arial, helvetica, sans-serif')
                            .text('Arial'))
                        .append($(document.createElement('option'))
                            .val('lucida sans unicode, lucida grande, sans-serif')
                            .text('Lucida Sans'))
                        .append($(document.createElement('option'))
                            .val('tahoma, geneva, sans-serif')
                            .text('Tahoma'))
                        .append($(document.createElement('option'))
                            .val('times new roman, times, serif')
                            .text('Times New Roman'))
                        .append($(document.createElement('option'))
                            .val('verdana, geneva, sans-serif')
                            .text('Verdana')));
                    if (!HTMLEditor.IsEmailEditor) {
                        var GoogleFontsOptGroup;
                        $Input.append(GoogleFontsOptGroup = $('<optgroup/>')
                            .attr("label", "Google Fonts")
                            .append($(document.createElement('option'))
                                .val('google:Alef')
                                .text('Alef'))
                            .append($(document.createElement('option'))
                                .val('google:Amatic SC')
                                .text('Amatic SC'))
                            .append($(document.createElement('option'))
                                .val('google:Arimo')
                                .text('Arimo'))
                            .append($(document.createElement('option'))
                                .val('google:David Libre')
                                .text('David Libre'))
                            .append($(document.createElement('option'))
                                .val('google:Tinos')
                                .text('Tinos')));
                        if (Parameter.Value.indexOf("google:") == 0) {
                            var ExistingOption = $Input.find("option").filter(function () { return $(this).val() == Parameter.Value });
                            if (ExistingOption.length == 0)
                                GoogleFontsOptGroup.append($(document.createElement('option'))
                                    .val(Parameter.Value)
                                    .text(Parameter.Value.substring("google:".length)));
                        }
                        GoogleFontsOptGroup.append($(document.createElement('option'))
                            .val('google:Custom')
                            .text('הזנה ידנית'));
                    }
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged_FontFamily));
                    break;
                }
                case "YouTubeVideoID":
                    $Field.append($(document.createElement('input'))
                        .attr("type", "text")
                        .addClass("ltr")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "CustomHTML":
                    InputClass = "input-LongText";
                    $Field.append($(document.createElement('textarea'))
                        .addClass("ltr")
                        .css("min-height", "200px")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "Schema":
                    InputClass = "input-Schema";
                    var $SchemaPicker = $(document.createElement('input'));
                    if (Parameter.Value != null && Parameter.Value.length > 0) {
                        var ParameterValue = JSON.parse(Parameter.Value);
                        $SchemaPicker.val(ParameterValue[0]).attr("data-schemaname", ParameterValue[1]);
                    }
                    $Field.append($SchemaPicker
                        .attr("type", "hidden")
                        .addClass("schemapicker")
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                case "View":
                    InputClass = "input-SchemaView";
                    var $SchemaPicker = $(document.createElement('input'));
                    var $ViewPicker = $(document.createElement('input'));
                    if (Parameter.Value != null && Parameter.Value.length > 0) {
                        var ParameterValue = JSON.parse(Parameter.Value);
                        $SchemaPicker.val(ParameterValue[0]).attr("data-schemaname", ParameterValue[1]);
                        $ViewPicker.val(ParameterValue[2]).attr("data-schemaid", ParameterValue[0]).attr("data-viewname", ParameterValue[3]);
                    }

                    $Field.append($(document.createElement('div'))
                        .addClass("schemaviewdetails")
                        .append($(document.createElement('div'))
                            .addClass("using-tooltip")
                            .attr("title", "תיקייה")
                            .append($SchemaPicker
                                .attr("type", "hidden")
                                .addClass("schemapicker")
                                .on("change", HTMLEditor.WidgetParameterChanged))
                        )
                        .append($(document.createElement('div'))
                            .addClass("using-tooltip")
                            .attr("title", "תצוגה")
                            .append($ViewPicker
                                .attr("type", "hidden")
                                .addClass("viewpicker simpleviewpicker")
                                .on("change", HTMLEditor.WidgetParameterChanged))
                        )
                    );
                    break;
                case "EntityLayout": {
                    InputClass = "input-Select";
                    var $Input = <any>$(document.createElement('select'));
                    $Input.append($(document.createElement('option'))
                        .val('center')
                        .text('ממורכז'));
                    $Input.append($(document.createElement('option'))
                        .val('start')
                        .text('תחילת שורה'));
                    $Input.append($(document.createElement('option'))
                        .val('row')
                        .text('שורה שלמה'));
                    $Field.append($Input
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                }
                case "EntityButtonText":
                    InputClass = "input-ShortText";
                    $Field.append($(document.createElement('input'))
                        .attr("type", "text")
                        .val(Parameter.Value)
                        .on("change", HTMLEditor.WidgetParameterChanged));
                    break;
                default:
                    alert("Unsupported ParameterType: " + Parameter.Type);
                    break;
            }

            $Field.addClass(InputClass);
            $Container.append($(document.createElement('div'))
                .addClass("sumit-field-label")
                .append($(document.createElement('div'))
                    .append($(document.createElement('label'))
                        .text(Parameter.DisplayName)
                    )
                    .append(Title == null ? null : $(document.createElement('div'))
                        .addClass("sumit-field-description using-tooltip")
                        .attr('title', Title))
                ));
            $Container.append($(document.createElement('div'))
                .addClass("sumit-field-value")
                .data("Widget", Widget)
                .data("Parameter", Parameter)
                .append($Field));
            return $Container;
        }

        static WidgetParameterChanged_FontFamily() {
            var $Input = $(this);
            if ($Input.val() == "google:Custom") {
                var Modal = OfficeGuy.Modals.ShowInputDialog({
                    Title: "בחירת גופן",
                    Message: "שם הגופן",
                    ConfirmText: "בחירה",
                    ConfirmEvent: function (Value) {
                        $Input.val("google:" + Value);
                        $.proxy(HTMLEditor.WidgetParameterChanged, $Input)();
                        Modals.Hide(Modal);
                    }
                });
            }
            else
                $.proxy(HTMLEditor.WidgetParameterChanged, $Input)();
        }

        static WidgetParameterChanged() {
            var $Input = <any>$(this);
            var $EditorField = $Input.closest(".sumit-field-value");
            var Widget = <HTMLEditor_Widget>$EditorField.data("Widget");
            var Parameter = <HTMLEditor_Parameter>$EditorField.data("Parameter");
            switch (Parameter.Type) {
                case "TextBold":
                    Parameter.Value = $Input.prop("checked") ? "1" : "0";
                    break;
                case "Schema":
                    var SchemaPicker = Teva.SelectBox.GetInstance($Input);
                    if (SchemaPicker.SelectedValue == null || SchemaPicker.SelectedValue.length == 0)
                        Parameter.Value = null;
                    else
                        Parameter.Value = JSON.stringify([SchemaPicker.SelectedValue, SchemaPicker.SelectedText]);
                    break;
                case "View":
                    var SchemaPicker = Teva.SelectBox.GetInstance($EditorField.find("input.schemapicker"));
                    var ViewPicker = Teva.SelectBox.GetInstance($EditorField.find("input.viewpicker"));
                    if (SchemaPicker.SelectedValue == null || SchemaPicker.SelectedValue.length == 0)
                        Parameter.Value = null;
                    else
                        Parameter.Value = JSON.stringify([SchemaPicker.SelectedValue, SchemaPicker.SelectedText, ViewPicker.SelectedValue, ViewPicker.SelectedText]);
                    break;
                case "WidthPercent":
                    Parameter.Value = <string>$Input.val();
                    if (Parameter.Value == null || Parameter.Value.length == 0 || Number(Parameter.Value) < 1)
                        Parameter.Value = "1";
                    var TotalPercent = Number(Parameter.Value);
                    var LastOtherColumnProperty = null;
                    for (var i = 0; i < Widget.Parameters.length; i++) {
                        if (Widget.Parameters[i].Type != "WidthPercent")
                            continue;

                        if (Widget.Parameters[i].Name == Parameter.Name)
                            continue;

                        LastOtherColumnProperty = Widget.Parameters[i];
                        TotalPercent += Number(Widget.Parameters[i].Value);
                    }

                    if (TotalPercent != 100) {
                        LastOtherColumnProperty.Value = Number(LastOtherColumnProperty.Value) - (TotalPercent - 100);
                        HTMLEditor.RenderParameter(Widget, LastOtherColumnProperty, false);
                        $Input.closest(".og-accordion").find("div.sumit-field[data-parametername=" + LastOtherColumnProperty.Name + "]").find("input").val(LastOtherColumnProperty.Value);
                    }
                case "ImageWidth":
                    if (Number($Input.val()) > 2000)
                        $Input.val("2000");
                    Parameter.Value = <string>$Input.val();
                    HTMLEditor.RenderParameter(Widget, Parameter, false);

                    var ImageParameter = HTMLEditor.Deserialize_FindParameterByName(Widget.Parameters, "Image");
                    var ImageHeightParameter = HTMLEditor.Deserialize_FindParameterByName(Widget.Parameters, "ImageHeight");
                    if (ImageParameter.Value != null && ImageParameter.Value.indexOf("myofficeguy.com/crm/downloadfile/") != -1) {
                        var Width;
                        if (Parameter.Value != null && Parameter.Value.length > 0)
                            Width = parseInt(Parameter.Value) * 2;
                        else
                            Width = 0;
                        var Height;
                        if (ImageHeightParameter.Value != null && ImageHeightParameter.Value.length > 0)
                            Height = parseInt(Parameter.Value) * 2;
                        else
                            Height = 0;

                        ImageParameter.Value = ImageParameter.Value.substring(0, ImageParameter.Value.lastIndexOf('/')) + '/?width=' + Width + '&height=' + ImageHeightParameter.Value;
                        HTMLEditor.RenderParameter(Widget, ImageParameter, false);
                    }
                    return;
                case "ImageHeight":
                    if (Number($Input.val()) > 2000)
                        $Input.val("2000");
                    Parameter.Value = <string>$Input.val();
                    break;

                default:
                    Parameter.Value = <string>$Input.val();
                    break;
            }
            HTMLEditor.RenderParameter(Widget, Parameter, false);
        }

        static PrepareStorage() {
            HTMLEditor.PrepareStorage_Widgets($(".htmleditor-content"));

            var Parameters = <Array<HTMLEditor_Parameter>>$(".htmleditor-editor").data("TemplateParameters");
            for (var i = 0; i < Parameters.length; i++) {
                var Parameter = Parameters[i];
                if (Parameter.$HTMLElements == null)
                    continue;

                if (Parameter.Type != "HTML" && Parameter.Type != "Text" && Parameter.Type != "ButtonText")
                    continue;

                var $Element = $(Parameter.$HTMLElements).clone(true, true);
                $Element.find(".og-richtexteditor")
                    .find("h1, h2, h3, h4, h5, h6").css("margin-top", "10px").css("margin-bottom", "10px").css("line-height", "1.5");
                $Element.find(".og-richtexteditor > *").unwrap();
                $Element.find(".og-richtexteditor")
                    .removeClass("og-richtexteditor")
                    .removeClass("og-richtexteditor-floating")
                    .removeAttr("id")
                    .removeAttr("contenteditable");
                Parameter.Value = $Element[0].innerHTML;
            }
        }
        static PrepareStorage_Widgets(Container) {
            var $Widgets = $(Container).find("> .htmleditor-widget");
            for (var i = 0; i < $Widgets.length; i++) {
                var Widget = <HTMLEditor_Widget>$($Widgets[i]).data("Widget");
                HTMLEditor.PrepareStorage_Widget(Widget);
            }
        }
        static PrepareStorage_Widget(Widget: HTMLEditor_Widget) {
            for (var i = 0; i < Widget.Parameters.length; i++) {
                var Parameter = Widget.Parameters[i];
                if (Parameter.Type == "HTML" || Parameter.Type == "Text" || Parameter.Type == "ButtonText") {
                    var $Element = $(Parameter.$HTMLElements).clone(true, true);
                    $Element.find(".og-richtexteditor")
                        .find("h1, h2, h3, h4, h5, h6").css("margin-top", "10px").css("margin-bottom", "10px").css("line-height", "1.5");
                    $Element.find(".og-richtexteditor > *").unwrap();
                    $Element.find(".og-richtexteditor")
                        .removeClass("og-richtexteditor")
                        .removeClass("og-richtexteditor-floating")
                        .removeAttr("id")
                        .removeAttr("contenteditable");
                    Parameter.Value = $Element[0].innerHTML;
                }
            }
            var $WidgetsContainer = Widget.$HTMLElement.find(".htmleditor-widgetcontainer").filter(function () {
                return $(this).closest(".htmleditor-widget")[0] == Widget.$HTMLElement[0];
            });
            if ($WidgetsContainer.length > 0) {
                for (var i = 0; i < $WidgetsContainer.length; i++)
                    HTMLEditor.PrepareStorage_Widgets($WidgetsContainer[i]);
            }
        }

        static Serialize() {
            var ToReturn = <any>{};
            ToReturn.Template = new Array();
            ToReturn.Widgets = HTMLEditor.SerializeWidgets($(".htmleditor-content"));

            var TemplateParameters = <Array<HTMLEditor_Parameter>>$(".htmleditor-editor").data("TemplateParameters");
            for (var i = 0; i < TemplateParameters.length; i++) {
                var Parameter = TemplateParameters[i];
                if (Parameter.Value == null || Parameter.Value.length == 0)
                    continue;

                ToReturn.Template.push({
                    Name: Parameter.Name,
                    Value: Parameter.Value
                });
            }

            return JSON.stringify(ToReturn);
        }
        static SerializeWidgets(Container) {
            var $Widgets = $(Container).find("> .htmleditor-widget");
            var ToReturn = new Array();
            for (var i = 0; i < $Widgets.length; i++) {
                var Widget = <HTMLEditor_Widget>$($Widgets[i]).data("Widget");
                var Item = HTMLEditor.SerializeWidget(Widget);
                ToReturn.push(Item);
            }
            return ToReturn;
        }
        static SerializeWidget(Widget: HTMLEditor_Widget) {
            var Item = <any>{};
            Item.Name = Widget.Name;
            Item.Parameters = [];
            for (var i = 0; i < Widget.Parameters.length; i++) {
                var Parameter = Widget.Parameters[i];
                if (Parameter.Value == null || Parameter.Value.length == 0)
                    continue;

                Item.Parameters.push({
                    Name: Parameter.Name,
                    Value: Parameter.Value
                });
            }
            var $WidgetsContainer = Widget.$HTMLElement.find(".htmleditor-widgetcontainer").filter(function () {
                return $(this).closest(".htmleditor-widget")[0] == Widget.$HTMLElement[0];
            });
            if ($WidgetsContainer.length > 0) {
                Item.Widgets = [];
                for (var i = 0; i < $WidgetsContainer.length; i++)
                    Item.Widgets.push(HTMLEditor.SerializeWidgets($WidgetsContainer[i]));
            }
            return Item;
        }

        static Deserialize(JSONValue) {
            var Deserialized = JSON.parse(JSONValue);
            var Widgets = <Array<HTMLEditor_Widget>>Deserialized.Widgets;
            var $Container = $('.htmleditor-content').empty();
            HTMLEditor.DeserializeWidgets($Container, Widgets);

            var JSONParameters = <Array<HTMLEditor_Parameter>>Deserialized.Template;
            var Parameters = <Array<HTMLEditor_Parameter>>$(".htmleditor-editor").data("TemplateParameters");
            for (var i = 0; i < Parameters.length; i++) {
                var Parameter = Parameters[i];
                var JSONParameter = HTMLEditor.Deserialize_FindParameterByName(JSONParameters, Parameter.Name);
                if (JSONParameter == null && Parameter.Name == "Padding")
                    continue;

                var Value = JSONParameter == null ? "" : JSONParameter.Value;
                if (Parameter.Value != Value) {
                    Parameter.Value = Value;
                    HTMLEditor.RenderParameter(null, Parameter, false);
                }
            }
            return Widgets;
        }
        static Deserialize_FindParameterByName(Parameters, Name) {
            for (var i = 0; i < Parameters.length; i++) {
                var Parameter = Parameters[i];
                if (Parameter.Name == Name)
                    return Parameter;
            }
            return null;
        }

        static DeserializeWidgets($Container, Widgets) {
            for (var i = 0; i < Widgets.length; i++)
                HTMLEditor.DeserializeWidget($Container, Widgets[i]);
        }
        static DeserializeWidget($Container, JSONWidget) {
            var Widget = <HTMLEditor_Widget>HTMLEditor.Function_CreateWidgetByName(JSONWidget.Name)
            for (var i = 0; i < Widget.Parameters.length; i++) {
                var Parameter = Widget.Parameters[i];
                var JSONParameter = HTMLEditor.Deserialize_FindParameterByName(JSONWidget.Parameters, Parameter.Name);
                var Value = JSONParameter == null ? "" : JSONParameter.Value;
                Parameter.Value = Value;
            }
            HTMLEditor.RenderWidget(Widget, false);
            $Container.append(Widget.$HTMLElement);

            if (JSONWidget.Widgets != null && JSONWidget.Widgets.length > 0) {
                var $Containers = Widget.$HTMLElement.find(".htmleditor-widgetcontainer").empty();
                for (var i = 0; i < $Containers.length; i++)
                    HTMLEditor.DeserializeWidgets($($Containers[i]), JSONWidget.Widgets[i]);
            }
        }

        static GenerateHTML() {
            var $ToReturn = $('.htmleditor-content').clone(true, true);
            $ToReturn.find(".htmleditor-widget > *").unwrap();
            $ToReturn.find(".htmleditor-widget-active").removeClass("htmleditor-widget-active");
            $ToReturn.find(".htmleditor-content").removeClass("htmleditor-content");
            $ToReturn.find(".htmleditor-widget-button-container").remove();
            $(".floating-richtext-buttons").remove();
            $ToReturn.find(".og-richtexteditor > *").unwrap();
            $ToReturn.find(".htmleditor-editor-imagecontainer > *").unwrap();
            $ToReturn.find(".og-richtexteditor").removeClass("RichTextEditor").removeClass("RichTextEditor-floating").removeAttr("id").removeAttr("contenteditable");
            $ToReturn.find("[og-email-parameter]").removeAttr("og-email-parameter");
            $ToReturn.find("[contenteditable]").removeAttr("contenteditable");
            $ToReturn.find('[class=""]').removeAttr('class');
            $ToReturn.find('[alt=""]').removeAttr('alt');
            $ToReturn.find('a[href]').filter(function () {
                return $(this).css("display") == "none";
            }).remove();
            $ToReturn.find('a[href=""] > *').unwrap();
            $ToReturn.find('a[href]').each(function () {
                $(this).attr("href", HTMLEditor.NormalizeHyperlink($(this).attr("href")));
            });
            $ToReturn.find(".htmleditor-appendwidgetbutton").remove();
            $ToReturn.find(".htmleditor-prependwidgetbutton").remove();
            $ToReturn.find(".og-email-header-logo").attr("src", "{CompanyLogo}");
            return $(document.createElement('div'))
                .text($ToReturn.html())
                .html();
        }

        static NormalizeHyperlink(URL) {
            if (URL == null || URL.length == 0)
                return URL;
            var LowerURL = URL.toLowerCase();
            if (LowerURL.indexOf("http://") == 0
                || LowerURL.indexOf("https://") == 0
                || LowerURL.indexOf("mailto:") == 0
                || LowerURL.indexOf("tel:") == 0
                || (LowerURL.indexOf("{") == 0 && LowerURL.indexOf("}") == LowerURL.length - 1))
                return URL;
            return "http://" + URL;
        }

        static ImagePicker($Image) {
            if (HTMLEditor.UploadImageURL == null) {
                Modals.ShowMessageDialog("החלפת תמונה", "על מנת להחליף תמונה, יש לשמור את הכרטיס תחילה.");
                return;
            }

            var Widget = <HTMLEditor_Widget>$Image.closest(".htmleditor-widget").data("Widget");
            var Parameter: HTMLEditor_Parameter;
            for (var i = 0; i < Widget.Parameters.length; i++) {
                if (Widget.Parameters[i].$HTMLElements[0] == $Image[0]) {
                    Parameter = Widget.Parameters[i];
                    break;
                }
            }
            var $Input = $(document.createElement('input'))
                .attr("type", "file")
                .attr("accept", "image/*")
                .on("change", function () {
                    var FileElement = <HTMLInputElement>$Input[0];
                    if (FileElement.files && FileElement.files[0] && FileElement.files[0].type.match('image.*')) {
                        var Reader = new FileReader();
                        Reader.readAsDataURL(FileElement.files[0]);

                        Reader.onload = function (e: any) {
                            var Width;
                            if ($Image.css("max-width") && $Image.css("max-width") != "none" && $Image.css("max-width").indexOf("px") != -1)
                                Width = parseInt($Image.css("max-width"), 10) * 2;
                            else
                                Width = 0;
                            var Height;
                            if ($Image.css("max-height") && $Image.css("max-height") != "none")
                                Height = parseInt($Image.css("max-height"), 10) * 2;
                            else
                                Height = 0;

                            var Data = new FormData();
                            Data.append(FileElement.files[0].name, FileElement.files[0]);

                            Common.AjaxRequest({
                                URL: HTMLEditor.UploadImageURL,
                                Data: Data,
                                ProcessData: false,
                                ContentType: false,
                                SuccessMethod: function (Response) {
                                    var FileID = Response.FileID;
                                    $("#RenderedFields_Version").val(Response.Version);
                                    $Image[0].src = OfficeGuy.Common.FullRootURL + "/crm/downloadfile/" + FileID + "/?width=" + Width + "&height=" + Height;
                                    Parameter.Value = OfficeGuy.Common.FullRootURL + "/crm/downloadfile/" + FileID + "/?width=" + Width + "&height=" + Height;
                                }
                            });
                        };
                    }
                })
                .trigger("click");
        }
        static BackgroundImagePicker(Parameter: HTMLEditor_Parameter) {
            if (HTMLEditor.UploadImageURL == null) {
                Modals.ShowMessageDialog("החלפת תמונה", "על מנת להחליף תמונה, יש לשמור את הכרטיס תחילה.");
                return;
            }

            var $Input = $(document.createElement('input'))
                .attr("type", "file")
                .attr("accept", "image/*")
                .on("change", function () {
                    var FileElement = <HTMLInputElement>$Input[0];
                    if (FileElement.files && FileElement.files[0] && FileElement.files[0].type.match('image.*')) {
                        var Reader = new FileReader();
                        Reader.readAsDataURL(FileElement.files[0]);

                        Reader.onload = function (e: any) {
                            var Data = new FormData();
                            Data.append(FileElement.files[0].name, FileElement.files[0]);

                            Common.AjaxRequest({
                                URL: HTMLEditor.UploadImageURL,
                                Data: Data,
                                ProcessData: false,
                                ContentType: false,
                                SuccessMethod: function (data) {
                                    var FileID = data.FileID;
                                    $("#RenderedFields_Version").val(data.Version);
                                    $(Parameter.$HTMLElements).css("background-image", "url(" + OfficeGuy.Common.FullRootURL + "/crm/downloadfile/" + FileID + "/)");
                                    Parameter.Value = OfficeGuy.Common.FullRootURL + "/crm/downloadfile/" + FileID + "/";
                                },
                            });
                        };
                    }
                })
                .trigger("click");
        }

        static HexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F");
        static RGB2Hex(RGB) {
            RGB = RGB.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
            if (RGB == null)
                return "";
            return "#" + HTMLEditor.Hex(RGB[1]) + HTMLEditor.Hex(RGB[2]) + HTMLEditor.Hex(RGB[3]);
        }
        static Hex(Value) {
            return isNaN(Value) ? "00" : HTMLEditor.HexDigits[(Value - Value % 16) / 16] + HTMLEditor.HexDigits[Value % 16];
        }
    }

    export class HTMLEditor_Widget {
        DisplayName: string;
        Name: string;
        Template: string;
        Parameters: HTMLEditor_Parameter[];
        $HTMLElement: any;
        Widgets: any;
    }

    export class HTMLEditor_Parameter {
        constructor(Category, DisplayName?, Name?, Type?, Value?) {
            this.Category = Category;
            this.DisplayName = DisplayName;
            this.Name = Name;
            this.Type = Type;
            this.Value = Value;
        }
        Category: string;
        DisplayName: string;
        Name: string;
        Type: string;
        Value: string;
        $HTMLElements: any;
    }
}
